import { type UseSortableInput, useSortable } from '@dnd-kit/react/sortable';

const unbound = (_element: Element | null) => {
  // Без права элемент к сортировке не привязывается
};

/**
 * Сортируемый элемент, который без права на перестановку перетаскиваемым не становится вовсе.
 *
 * Выключенный `useSortable` всё равно размечает привязанный элемент (или ручку) как перетаскиваемый:
 * роль кнопки, своя остановка Tab, `aria-disabled` — и экранный диктор с автоматизацией считают
 * открываемый кликом узел недоступным. Поэтому без права `ref` и `handleRef` ни к чему не привязываются.
 *
 * @param allowed Право пользователя переставлять элементы
 */
export const useSortableWhenAllowed = (input: UseSortableInput, allowed: boolean) => {
  const { ref, handleRef, isDragging } = useSortable({ ...input, disabled: input.disabled || !allowed });
  return allowed ? { ref, handleRef, isDragging } : { ref: unbound, handleRef: unbound, isDragging: false };
};
